export default __webpack_public_path__ + "static/media/SiebenAuthBg.58649391.jpeg";